/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {correctFinplatInstrumentLinkToken} from '../api'

export const useMutationCorrectFinplatInstrumentLinkToken = createReactQueryMutationHook('correctFinplatInstrumentLinkToken', correctFinplatInstrumentLinkToken)
